<template>
	<div class="progress-bar">
		<div class="progress-bar__inner"
			:style="`width:${steps*16.67}%;`"
		></div><!-- /.progress-bar__inner -->
	</div><!-- /.progress-bar -->
</template>

<script>
export default {
	/**
	 * Component Name.
	 *
	 * @type {String}
	 */
	name: 'the-progress-bar',
	props:{
		steps: {
			type: Number,
			defatul() {
				return null;
			}
		},
	}
};
</script>

<style>
	.progress-bar { position: relative; height: 5px; background: #cccdc8; width: 100%; overflow: hidden; }
	.progress-bar .progress-bar__inner {position: absolute; top: 0; left: 0; width: 0; height: 100%; background: #a27c2c; transition: width 1s; }
</style>


// WEBPACK FOOTER //
// src/components/TheProgressBar.vue